export default __webpack_public_path__ + "static/media/card-back.32b64822.webp";